var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");

var trimmedEndIndex = require('./_trimmedEndIndex');
/** Used to match leading whitespace. */


var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim(string) {
  return string ? _sliceInstanceProperty(string).call(string, 0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

module.exports = baseTrim;